module.exports = __webpack_public_path__ + "static/media/pomme-de-terre.a39cbab2.svg";